import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import DataTable from '../../../components/DataTable';
import PendingQuoteTable from '../../../components/PendingQuoteTable';
import Page from '../../../components/Page';


import Modal from '../../../components/Modal';
import BlankState from '../../../components/BlankState';

import { listQuoteGoods, fetchPendingPolicies } from '../../../actions/policies';

//import { getPendingQuotes, getQuoteGoods } from '../../../utils/apiService';


class PendingQuotes extends Component{

	constructor(props){
		super(props);

		this.state = {
			active_quote: {}
		};
	}

	componentDidMount() {
		this.props.fetchPendingPolicies();
    }
	
	viewPendingQuotes(quote){
        this.setState({
			active_quote: quote
		});

		this.props.listQuoteGoods(quote.id);
	}

	render(){
		const { policies } = this.props;

		return(
			<Page isAdminPage={ true } pageTitle="Pending Quotes">
				<div className="clearfix">
					<div className="card">
						{ policies.pending_policies.length > 0 ?

							<DataTable 
								tableId="pending-quotes-table"
								columnTitles={ 
									["Policy Holder", "Creator", "Creator Email",  "Creator Phone", 
									"Intermediary", "Premium", "CFR", "Sum Insured", "Created On", "Action"]
									}>

							{
								policies.pending_policies.map((pending_quote, index)=>{
									const { proposer_name, creator_name, creator_email, creator_phone, intermediary_name, 
										premium, total_cfr, total_sum_insured, created } = pending_quote;

									return(
										<tr key={ index } >
											<td>{ proposer_name || '-' }</td>
											<td>{ creator_name || '-' }</td>
											<td>{ creator_email || '-' }</td>
											<td>{ creator_phone || '-' }</td>
											<td>{ intermediary_name || 'No' }</td>
											<td>{ numeral(premium).format('0,0.00') }</td>
											<td>{ numeral(total_cfr).format('0,0.00') }</td>
											<td>{ numeral(total_sum_insured).format('0,0.00') }</td>
											<td>{ moment(created).format('MMM Do, YYYY') }</td>
											<td>
												<button
													data-toggle="modal" 
													data-target=".view-quotes-modal"
													className="btn btn-success btn-sm"
													onClick={ ()=>{ this.viewPendingQuotes(pending_quote) } }>

													View
												</button>
											</td>
										</tr>
									)
								})
							}
							</DataTable>
						:
							<BlankState 
								data={ policies.pending_policies } 
								dataName="Pending Quotes" 
								isDataLoading={ policies.pending_policies_loading } />
						}
						
						<Modal 
							title="Pending Quotes"
							className="view-quotes-modal"
							closable={ true }>

							<PendingQuoteTable quote={ this.state.active_quote } />
						</Modal>
					</div>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user,
	policies: state.policies
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ fetchPendingPolicies, listQuoteGoods }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingQuotes);


// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/PendingQuotes.jsx